import { EMergeKey, EMergeLabel } from '@/editor/types/enums';

export const userMergeTags = [
  {
    label: EMergeLabel.FirstName,
    value: EMergeKey.firstName,
  },
  {
    label: EMergeLabel.LastName,
    value: EMergeKey.lastName,
  },
  {
    label: EMergeLabel.Title,
    value: EMergeKey.title,
  },
  {
    label: EMergeLabel.Email,
    value: EMergeKey.email,
  },
  {
    label: EMergeLabel.Mobile,
    value: EMergeKey.mobile,
  },
  {
    label: EMergeLabel.CompanyName,
    value: EMergeKey.companyName,
  },
  {
    label: EMergeLabel.OrganisationNumber,
    value: EMergeKey.companyNumber,
  },
];
